import { Component, OnInit, Output, EventEmitter, Input, inject } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { appReducer, documentActions } from '@app-root-store';
import { Store } from '@ngrx/store';
import { IFolder } from '@app-root-interfaces';
import { SiToastNotificationService } from '@siemens/element-ng/toast-notification';
import { duplicateFolder } from '../../validators/duplicate-folder.validator';

@Component({
    selector: 'app-create-folder',
    templateUrl: './create-folder.component.html',
    styleUrls: ['./create-folder.component.scss'],
    standalone: false
})
export class CreateFolderComponent implements OnInit {
    private fb = inject(FormBuilder);
    private store$ = inject<Store<appReducer.AppState>>(Store);
    private toastNotificationService = inject(SiToastNotificationService);

    @Input() folders: IFolder[] = [];
    @Output() canceled = new EventEmitter<void>();

    public inputGroup: FormGroup;

    ngOnInit() {
        this.createForm();
    }

    private createForm() {
        this.inputGroup = this.fb.group({
            input: ['', [Validators.required, duplicateFolder(this.folders)]]
        });
    }

    public createFolder() {
        if (this.inputGroup.valid) {
            const formValues = this.inputGroup.getRawValue();
            this.store$.dispatch(documentActions.createFolder({ name: formValues.input }));
            this.cancel();
        } else {
            if (this.inputGroup.hasError('duplicateFolder', ['input'])) {
                this.toastNotificationService.queueToastNotification(
                    'warning',
                    'Folder already exists',
                    'A folder with this name already exists in this directory.'
                );
            } else {
                this.toastNotificationService.queueToastNotification(
                    'warning',
                    'Invalid folder name',
                    'The name of the folder cannot be empty.'
                );
            }
        }
    }

    public cancel() {
        this.inputGroup.reset();
        this.canceled.emit();
    }
}
